class FormCheckbox {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    // フォーム二重送信対策
    $('.submit-btn').click(function() {
      $(this).css({'pointerEvents':'none'});
    })
  }
}
